import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createSha256Transformer, createTimestampTransformer } from '../common/sql';
import { DBQuestionDigitisationRunSchema, QuestionDigitisationRunSchema } from './schemas';

export const QuestionDigitisationRunCodecConfig: TransformerConfig<
  typeof QuestionDigitisationRunSchema,
  typeof DBQuestionDigitisationRunSchema
> = {
  name: 'QuestionDigitisationRun',
  clientSchema: QuestionDigitisationRunSchema,
  dbSchema: DBQuestionDigitisationRunSchema,
  transformers: [
    createSha256Transformer<
      typeof QuestionDigitisationRunSchema,
      typeof DBQuestionDigitisationRunSchema
    >('configHash'),
    ...(['startedAt', 'finishedAt', 'updatedAt'] as const).map(field =>
      createTimestampTransformer<
        typeof QuestionDigitisationRunSchema,
        typeof DBQuestionDigitisationRunSchema
      >(field, { nullable: true })
    ),
    createTimestampTransformer<
      typeof QuestionDigitisationRunSchema,
      typeof DBQuestionDigitisationRunSchema
    >('createdAt'),
  ],
};

export const encodeQuestionDigitisationRunToDb = createEncodeToDbFn(
  QuestionDigitisationRunCodecConfig
);
export const decodeQuestionDigitisationRunFromDb = createDecodeFromDbFn(
  QuestionDigitisationRunCodecConfig
);
